// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c6dntv0 {
  opacity: 0;
  position: absolute;
}
.c6dntv1 {
  width: var(--_18w76bwp);
  height: var(--_18w76bwj);
  position: relative;
  cursor: pointer;
  border-radius: 16px;
  background-color: var(--_18w76bw2k);
}
.c6dntv0:checked + .c6dntv1 {
  background-color: var(--_18w76bw31);
}
.c6dntv1::after {
  content: "";
  position: absolute;
  top: var(--_18w76bwa);
  left: 6.6666%;
  width: var(--_18w76bwi);
  height: var(--_18w76bwi);
  background: var(--_18w76bw24);
  border-radius: 50%;
  transition: .3s;
}
.c6dntv0:checked + .c6dntv1::after {
  left: 46px;
  transform: translateX(-100%);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,UAAU;EACV,4BAA4B;AAC9B","sourcesContent":[".c6dntv0 {\n  opacity: 0;\n  position: absolute;\n}\n.c6dntv1 {\n  width: var(--_18w76bwp);\n  height: var(--_18w76bwj);\n  position: relative;\n  cursor: pointer;\n  border-radius: 16px;\n  background-color: var(--_18w76bw2k);\n}\n.c6dntv0:checked + .c6dntv1 {\n  background-color: var(--_18w76bw31);\n}\n.c6dntv1::after {\n  content: \"\";\n  position: absolute;\n  top: var(--_18w76bwa);\n  left: 6.6666%;\n  width: var(--_18w76bwi);\n  height: var(--_18w76bwi);\n  background: var(--_18w76bw24);\n  border-radius: 50%;\n  transition: .3s;\n}\n.c6dntv0:checked + .c6dntv1::after {\n  left: 46px;\n  transform: translateX(-100%);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
